import PropTypes from 'prop-types';
import _ from 'lodash';
import MarkdownToHtml from '../../MarkdownToHtml';

const FlightCancellationPolicy = ({ flightItinerary }) => {
  const flight = flightItinerary.flightSegments?.flatMap((s) => s.flights ?? [])?.[0];

  let tripType = 'Flight';
  if (flightItinerary.isOneWay) tripType = 'One-way';
  if (flightItinerary.isTwoSegmentRoundTrip) tripType = 'Round-trip';
  if (flightItinerary.isMultiCity) tripType = 'Multi-city';

  const location = flightItinerary.isMultiCity
    ? _.map(flightItinerary.flightSegments, (fs) => ` ${(fs.originGeoname).city} (${fs.originAirportCode}) to ${(fs.destinationGeoname).city} (${fs.destinationAirportCode})`).join(' / ')
    : ` ${(flightItinerary.flightSegments[0].originGeoname).city} (${flightItinerary.flightSegments[0].originAirportCode}) to ${(flightItinerary.flightSegments[0].destinationGeoname).city} (${flightItinerary.flightSegments[0].destinationAirportCode})`;

  return (
    <div>
      { flight
        ? (
          <div key={flight.flightNumber + flight.departDateTime} className="my-2">
            {tripType}
            {' '}
            flight from
            {location}
            {' '}
            has the following refund and change policies:
          </div>
        ) : <></>}
      <MarkdownToHtml
        content={flight.selectedFareCancellationPolicy}
        className="prose-ul prose-p"
      />
    </div>
  );
};
FlightCancellationPolicy.propTypes = {
  flightItinerary: PropTypes.shape().isRequired,
};
export default FlightCancellationPolicy;
